<div
    class="p-6 min-h-screen bg-[#F3F4F6] text-xs dark:bg-slate-900   text-slate-600 dark:text-slate-300 relative overflow-hidden">

    <!-- Decorative Background -->
    <div
        class="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] bg-amber-400/5 rounded-full blur-[120px] pointer-events-none">
    </div>
    <div
        class="absolute bottom-[-10%] left-[-10%] w-[400px] h-[400px] bg-indigo-500/5 rounded-full blur-[100px] pointer-events-none">
    </div>

    <!-- ── Header ── -->
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
        <div>
            <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">จัดการบริษัทผู้เช่า
            </h1>
            <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium text-sm">
                จัดการและตรวจสอบข้อมูลบริษัทที่เช่าพื้นที่ พร้อมสรุปยอดสิทธิ์การจอดรถ</p>
        </div>
        <div class="flex items-center gap-3 w-full sm:w-auto">
            <button (click)="loadData()"
                class="w-full sm:w-auto p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 flex items-center justify-center h-[46px]"
                title="รีเฟรชข้อมูล">
                <span class="material-icons">refresh</span>
            </button>
            <button (click)="onCreate()"
                class="w-full sm:w-auto px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-[0_4px_15px_rgb(251,191,36,0.3)] hover:shadow-[0_8px_25px_rgb(251,191,36,0.4)] hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-2 h-[46px]">
                <span class="material-icons text-xl">add_business</span>
                เพิ่มบริษัทผู้เช่า
            </button>
        </div>
    </div>

    <!-- ── Stat Cards ── -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-8">
        <!-- Card 1 -->
        <div
            class="animate-fade-in bg-white dark:bg-slate-800 rounded-2xl p-5 shadow-[0_4px_20px_rgb(0,0,0,0.04)] border border-slate-100 dark:border-slate-700 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgb(0,0,0,0.07)] transition-all duration-300 relative overflow-hidden group">
            <div
                class="absolute -right-5 -top-5 w-28 h-28 rounded-full bg-amber-400 opacity-[0.07] group-hover:scale-110 transition-transform">
            </div>
            <div class="flex items-center justify-between mb-3 relative z-10">
                <div
                    class="w-10 h-10 rounded-xl bg-amber-50 dark:bg-amber-900/20 text-amber-500 flex items-center justify-center shadow-sm">
                    <span class="material-icons text-xl">group_work</span>
                </div>
                <span
                    class="text-[10px] font-black text-amber-400 bg-amber-50 dark:bg-amber-900/20 px-2 py-0.5 rounded-full">บริษัท</span>
            </div>
            <div class="relative z-10">
                <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">จำนวนบริษัทผู้เช่า</p>
                <div class="text-2xl font-black text-slate-800 dark:text-white">{{ totalItems | number }}</div>
            </div>
        </div>

        <!-- Card 2 -->
        <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-2xl p-5 shadow-[0_4px_20px_rgb(0,0,0,0.04)] border border-slate-100 dark:border-slate-700 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgb(0,0,0,0.07)] transition-all duration-300 relative overflow-hidden group"
            style="animation-delay:80ms">
            <div
                class="absolute -right-5 -top-5 w-28 h-28 rounded-full bg-indigo-500 opacity-[0.07] group-hover:scale-110 transition-transform">
            </div>
            <div class="flex items-center justify-between mb-3 relative z-10">
                <div
                    class="w-10 h-10 rounded-xl bg-indigo-50 dark:bg-indigo-900/20 text-indigo-500 flex items-center justify-center shadow-sm">
                    <span class="material-icons text-xl">confirmation_number</span>
                </div>
                <span
                    class="text-[10px] font-black text-indigo-400 bg-indigo-50 dark:bg-indigo-900/20 px-2 py-0.5 rounded-full">สิทธิ์</span>
            </div>
            <div class="relative z-10">
                <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">สิทธิ์จอดรถทั้งหมด</p>
                <div class="text-2xl font-black text-slate-800 dark:text-white">{{ totalQuota | number }}</div>
            </div>
        </div>

        <!-- Card 3 -->
        <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-2xl p-5 shadow-[0_4px_20px_rgb(0,0,0,0.04)] border border-slate-100 dark:border-slate-700 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgb(0,0,0,0.07)] transition-all duration-300 relative overflow-hidden group"
            style="animation-delay:160ms">
            <div
                class="absolute -right-5 -top-5 w-28 h-28 rounded-full bg-rose-500 opacity-[0.07] group-hover:scale-110 transition-transform">
            </div>
            <div class="flex items-center justify-between mb-3 relative z-10">
                <div
                    class="w-10 h-10 rounded-xl bg-rose-50 dark:bg-rose-900/20 text-rose-500 flex items-center justify-center shadow-sm">
                    <span class="material-icons text-xl">pie_chart</span>
                </div>
                <span
                    class="text-[10px] font-black text-rose-400 bg-rose-50 dark:bg-rose-900/20 px-2 py-0.5 rounded-full">ใช้แล้ว</span>
            </div>
            <div class="relative z-10">
                <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">สิทธิ์ที่ใช้ไปแล้ว</p>
                <div class="text-2xl font-black text-slate-800 dark:text-white">{{ totalUsed | number }}</div>
            </div>
        </div>

        <!-- Card 4 -->
        <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-2xl p-5 shadow-[0_4px_20px_rgb(0,0,0,0.04)] border border-slate-100 dark:border-slate-700 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgb(0,0,0,0.07)] transition-all duration-300 relative overflow-hidden group"
            style="animation-delay:240ms">
            <div
                class="absolute -right-5 -top-5 w-28 h-28 rounded-full bg-emerald-500 opacity-[0.07] group-hover:scale-110 transition-transform">
            </div>
            <div class="flex items-center justify-between mb-3 relative z-10">
                <div
                    class="w-10 h-10 rounded-xl bg-emerald-50 dark:bg-emerald-900/20 text-emerald-500 flex items-center justify-center shadow-sm">
                    <span class="material-icons text-xl">directions_car</span>
                </div>
                <span
                    class="text-[10px] font-black text-emerald-500 bg-emerald-50 dark:bg-emerald-900/20 px-2 py-0.5 rounded-full flex items-center gap-1">
                    <span class="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse inline-block"></span>
                    Active
                </span>
            </div>
            <div class="relative z-10">
                <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">รถใช้สิทธิ์เข้าจอด</p>
                <div class="text-2xl font-black text-slate-800 dark:text-white">{{ carUsedInStatus | number }}</div>
            </div>
        </div>
    </div>

    <!-- ── Main Content Card ── -->
    <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.04)] border border-slate-100 dark:border-slate-700 overflow-hidden"
        style="animation-delay:0.2s">

        <!-- Table Toolbar -->
        <div
            class="px-6 py-4 border-b border-slate-100 dark:border-slate-700 flex flex-col xl:flex-row xl:items-center justify-between gap-4">
            <div class="flex items-center gap-3">
                <div
                    class="w-9 h-9 rounded-xl bg-amber-50 dark:bg-amber-900/20 text-amber-500 flex items-center justify-center">
                    <span class="material-icons text-lg">business</span>
                </div>
                <div>
                    <h3 class="text-base font-bold text-slate-800 dark:text-slate-100 leading-none">รายการบริษัทผู้เช่า
                    </h3>
                    <p class="text-[11px] text-slate-400 dark:text-slate-500 mt-0.5">ทั้งหมด <span
                            class="font-bold text-slate-600 dark:text-slate-300">{{ totalItems | number }}</span> บริษัท
                    </p>
                </div>
            </div>

            <div class="flex flex-col sm:flex-row gap-3 w-full xl:w-auto">
                <!-- Filter Toggle -->
                <button (click)="toggleFilterPanel()"
                    class="flex items-center justify-between gap-2 px-4 py-2.5 rounded-xl border transition-all text-sm font-bold h-[42px]"
                    [ngClass]="showFilterPanel ? 'bg-amber-50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-700/50 text-amber-600 dark:text-amber-400' : 'bg-slate-50 dark:bg-slate-900 border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-800'">
                    <span class="flex items-center gap-1.5">
                        <span class="material-icons text-lg">{{ showFilterPanel ? 'filter_alt_off' : 'filter_alt'
                            }}</span>
                        ตัวกรอง
                    </span>
                    <span class="material-icons text-sm transition-transform duration-200"
                        [class.rotate-180]="showFilterPanel">expand_more</span>
                </button>

                <!-- Search Bar -->
                <div
                    class="flex items-center h-[42px] bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-2xl shadow-sm focus-within:ring-2 focus-within:ring-amber-300/40 focus-within:border-amber-400 focus-within:bg-white dark:focus-within:bg-slate-800 transition-all xl:min-w-[380px]">
                    <div class="pl-4 flex items-center shrink-0">
                        <span class="material-icons text-slate-400 text-lg">search</span>
                    </div>
                    <input type="text" placeholder="ค้นหาชื่อบริษัท, เบอร์โทร, เลขผู้เสียภาษี..."
                        [(ngModel)]="searchText" (input)="onSearch()"
                        class="flex-1 h-full px-3 bg-transparent border-none text-sm text-slate-700 dark:text-slate-200 font-medium focus:ring-0 focus:outline-none placeholder:text-slate-400 dark:placeholder:text-slate-500">
                    <button (click)="onSearch()"
                        class="h-full px-5 bg-amber-400 hover:bg-amber-500 text-white text-xs font-black uppercase tracking-widest rounded-r-2xl transition-colors">
                        ค้นหา
                    </button>
                </div>
            </div>
        </div>

        <!-- Advanced Filter Panel -->
        <div *ngIf="showFilterPanel"
            class="px-6 py-4 bg-slate-50/60 dark:bg-slate-900/30 border-b border-slate-100 dark:border-slate-700 animate-fade-in">
            <div class="flex items-center justify-between mb-4">
                <h4 class="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] flex items-center gap-1.5">
                    <span class="material-icons text-sm">tune</span>ตั้งค่าตัวกรอง
                </h4>
                <button (click)="resetFilters()"
                    class="text-[10px] font-black text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/10 px-3 py-1 rounded-full transition-all">ล้างทั้งหมด</button>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <!-- Provider -->
                <div class="space-y-1.5 relative">
                    <label class="text-[10px] font-black text-slate-500 uppercase tracking-widest">ผู้ให้บริการ</label>
                    <div
                        class="relative h-10 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl flex items-center shadow-sm focus-within:border-amber-400 transition-all overflow-hidden">
                        <input type="text" [(ngModel)]="searchProviderText" (focus)="toggleDropdown('provider', $event)"
                            (blur)="closeDropdowns()" placeholder="ทุกผู้ให้บริการ"
                            class="w-full h-full px-3 bg-transparent border-none text-xs font-bold text-slate-800 dark:text-slate-200 focus:ring-0 placeholder:text-slate-400">
                        <span
                            class="material-icons text-sm text-slate-400 pr-3 pointer-events-none transition-transform"
                            [class.rotate-180]="activeDropdown === 'provider'">expand_more</span>
                    </div>
                    <div *ngIf="activeDropdown === 'provider'" (mousedown)="$event.preventDefault()"
                        class="absolute top-full left-0 right-0 mt-1 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 z-20 py-1 animate-fade-in">
                        <div (click)="selectFilter('provider', '')"
                            class="px-4 py-2 text-xs font-bold hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 cursor-pointer flex items-center justify-between">
                            <span>ทั้งหมด</span><span *ngIf="!filterProvider"
                                class="material-icons text-amber-500 text-sm">check</span>
                        </div>
                        <div *ngFor="let opt of filteredProviderOptions" (click)="selectFilter('provider', opt)"
                            class="px-4 py-2 text-xs font-bold hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 cursor-pointer flex items-center justify-between">
                            <span>{{ opt }}</span><span *ngIf="filterProvider === opt"
                                class="material-icons text-amber-500 text-sm">check</span>
                        </div>
                    </div>
                </div>
                <!-- Site -->
                <div class="space-y-1.5 relative">
                    <label class="text-[10px] font-black text-slate-500 uppercase tracking-widest">โครงการ
                        (Site)</label>
                    <div
                        class="relative h-10 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl flex items-center shadow-sm focus-within:border-amber-400 transition-all overflow-hidden">
                        <input type="text" [(ngModel)]="searchSiteText" (focus)="toggleDropdown('site', $event)"
                            (blur)="closeDropdowns()" placeholder="ทุกโครงการ"
                            class="w-full h-full px-3 bg-transparent border-none text-xs font-bold text-slate-800 dark:text-slate-200 focus:ring-0 placeholder:text-slate-400">
                        <span
                            class="material-icons text-sm text-slate-400 pr-3 pointer-events-none transition-transform"
                            [class.rotate-180]="activeDropdown === 'site'">expand_more</span>
                    </div>
                    <div *ngIf="activeDropdown === 'site'" (mousedown)="$event.preventDefault()"
                        class="absolute top-full left-0 right-0 mt-1 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 z-20 py-1 animate-fade-in max-h-48 overflow-y-auto custom-scrollbar">
                        <div (click)="selectFilter('site', '')"
                            class="px-4 py-2 text-xs font-bold hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 cursor-pointer flex items-center justify-between">
                            <span>ทั้งหมด</span><span *ngIf="!filterSite"
                                class="material-icons text-amber-500 text-sm">check</span>
                        </div>
                        <div *ngFor="let opt of filteredSiteOptions" (click)="selectFilter('site', opt)"
                            class="px-4 py-2 text-xs font-bold hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 cursor-pointer flex items-center justify-between">
                            <span>{{ opt }}</span><span *ngIf="filterSite === opt"
                                class="material-icons text-amber-500 text-sm">check</span>
                        </div>
                    </div>
                </div>
                <!-- Type -->
                <div class="space-y-1.5 relative">
                    <label class="text-[10px] font-black text-slate-500 uppercase tracking-widest">ประเภทผู้เช่า</label>
                    <div
                        class="relative h-10 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl flex items-center shadow-sm focus-within:border-amber-400 transition-all overflow-hidden">
                        <input type="text" [(ngModel)]="searchTypeText" (focus)="toggleDropdown('type', $event)"
                            (blur)="closeDropdowns()" placeholder="ทุกประเภท"
                            class="w-full h-full px-3 bg-transparent border-none text-xs font-bold text-slate-800 dark:text-slate-200 focus:ring-0 placeholder:text-slate-400">
                        <span
                            class="material-icons text-sm text-slate-400 pr-3 pointer-events-none transition-transform"
                            [class.rotate-180]="activeDropdown === 'type'">expand_more</span>
                    </div>
                    <div *ngIf="activeDropdown === 'type'" (mousedown)="$event.preventDefault()"
                        class="absolute top-full left-0 right-0 mt-1 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 z-20 py-1 animate-fade-in">
                        <div (click)="selectFilter('type', '')"
                            class="px-4 py-2 text-xs font-bold hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 cursor-pointer flex items-center justify-between">
                            <span>ทั้งหมด</span><span *ngIf="!filterType"
                                class="material-icons text-amber-500 text-sm">check</span>
                        </div>
                        <div *ngFor="let opt of filteredTypeOptions" (click)="selectFilter('type', opt)"
                            class="px-4 py-2 text-xs font-bold hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 cursor-pointer flex items-center justify-between">
                            <span>{{ opt }}</span><span *ngIf="filterType === opt"
                                class="material-icons text-amber-500 text-sm">check</span>
                        </div>
                    </div>
                </div>
            </div>
            <button (click)="activeDropdown = null" *ngIf="activeDropdown"
                class="fixed inset-0 z-10 cursor-default"></button>
        </div>

        <!-- ── Table ── -->
        <div class="overflow-x-auto min-h-[400px] relative custom-scrollbar" [class.opacity-50]="isLoading">
            <table class="w-full text-left border-separate border-spacing-0 min-w-[1300px]">
                <thead
                    class="text-[10px] text-slate-400 dark:text-slate-500 uppercase tracking-wider bg-slate-50/80 dark:bg-slate-800/80 sticky top-0 z-10 backdrop-blur-sm">
                    <tr>
                        <th (click)="sortData('id')"
                            class="px-5 py-3.5 font-bold cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 border-b border-slate-100 dark:border-slate-700/50 w-[60px] text-center">
                            <div class="flex items-center justify-center gap-1">ID
                                <span class="material-icons text-[11px] text-amber-500 opacity-0"
                                    [class.opacity-100]="sortColumn === 'id'">{{ sortDirection === 'asc' ?
                                    'arrow_upward' : 'arrow_downward' }}</span>
                            </div>
                        </th>
                        <th (click)="sortData('name')"
                            class="px-5 py-3.5 font-bold cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 border-b border-slate-100 dark:border-slate-700/50 w-[22%]">
                            <div class="flex items-center gap-1">ชื่อบริษัท
                                <span class="material-icons text-[11px] text-amber-500 opacity-0"
                                    [class.opacity-100]="sortColumn === 'name'">{{ sortDirection === 'asc' ?
                                    'arrow_upward' : 'arrow_downward' }}</span>
                            </div>
                        </th>
                        <th class="px-5 py-3.5 font-bold border-b border-slate-100 dark:border-slate-700/50 w-[15%]">
                            ติดต่อ</th>
                        <th class="px-5 py-3.5 font-bold border-b border-slate-100 dark:border-slate-700/50 w-[12%]">
                            สถานที่ / ผู้ให้บริการ</th>
                        <th class="px-5 py-3.5 font-bold border-b border-slate-100 dark:border-slate-700/50 w-[10%]">
                            ประเภท</th>
                        <th
                            class="px-5 py-3.5 font-bold border-b border-slate-100 dark:border-slate-700/50 text-center w-[18%]">
                            สิทธิ์ (Used / Quota)</th>
                        <th
                            class="px-5 py-3.5 font-bold border-b border-slate-100 dark:border-slate-700/50 text-center w-[10%]">
                            รถที่เข้าจอด</th>
                        <th
                            class="px-5 py-3.5 font-bold border-b border-slate-100 dark:border-slate-700/50 text-center w-[8%]">
                            จัดการ</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of paginatedItems"
                        class="group border-b border-slate-50 dark:border-slate-700/30 hover:bg-amber-50/40 dark:hover:bg-slate-700/20 transition-colors duration-150">

                        <!-- ID -->
                        <td class="px-5 py-4 text-center align-middle">
                            <span class="text-[11px] font-mono font-bold text-slate-400 dark:text-slate-500">#{{ item.id
                                }}</span>
                        </td>

                        <!-- Company Name + Address -->
                        <td class="px-5 py-4 align-middle">
                            <div class="flex flex-col gap-0.5">
                                <span class="text-sm font-black text-slate-800 dark:text-white leading-tight">{{
                                    item.name }}</span>
                                <span
                                    class="text-[10px] text-slate-400 dark:text-slate-500 line-clamp-2 leading-relaxed">{{
                                    item.address || '-' }}</span>
                                <span *ngIf="item.branch"
                                    class="text-[10px] font-semibold text-indigo-500 dark:text-indigo-400 mt-0.5">สาขา:
                                    {{ item.branch }}</span>
                            </div>
                        </td>

                        <!-- Contact Info -->
                        <td class="px-5 py-4 align-middle">
                            <div class="flex flex-col gap-1">
                                <span
                                    class="inline-flex items-center gap-1 text-[11px] font-bold text-slate-600 dark:text-slate-300">
                                    <span class="material-icons text-[13px] text-slate-400">phone</span>{{ item.phone ||
                                    '-' }}
                                </span>
                                <span *ngIf="item.contactPerson"
                                    class="inline-flex items-center gap-1 text-[10px] text-slate-400 dark:text-slate-500">
                                    <span class="material-icons text-[12px]">person</span>{{ item.contactPerson }}
                                </span>
                                <span *ngIf="item.taxId"
                                    class="text-[10px] font-mono text-slate-400 dark:text-slate-500 truncate max-w-[160px]">{{
                                    item.taxId }}</span>
                            </div>
                        </td>

                        <!-- Site + Provider -->
                        <td class="px-5 py-4 align-middle">
                            <div class="flex flex-col gap-1">
                                <span
                                    class="inline-flex items-center gap-1 text-[11px] font-bold text-slate-600 dark:text-slate-300">
                                    <span class="material-icons text-[13px] text-amber-400">location_on</span>
                                    <span class="truncate max-w-[120px]">{{ item.siteName || '-' }}</span>
                                </span>
                                <span class="text-[10px] text-slate-400 dark:text-slate-500 truncate max-w-[120px]">{{
                                    item.providerName || '-' }}</span>
                            </div>
                        </td>

                        <!-- Tenant Type  -->
                        <td class="px-5 py-4 align-middle">
                            <span
                                class="inline-flex items-center px-2 py-0.5 rounded-lg bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600 dark:text-indigo-400 font-black text-[10px] uppercase tracking-wide">
                                {{ item.tenantType || '-' }}
                            </span>
                            <span *ngIf="item.wh !== null && item.wh !== undefined"
                                class="ml-1 inline-flex items-center px-1.5 py-0.5 rounded-md bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400 font-bold text-[10px]">
                                WH: {{ item.wh }}
                            </span>
                        </td>

                        <!-- Used / Quota with progress bar -->
                        <td class="px-5 py-4 align-middle">
                            <div class="flex flex-col items-center gap-1.5">
                                <div class="flex items-center gap-1.5">
                                    <span class="text-sm font-black"
                                        [ngClass]="(item.reserveUsed / item.reserveQuota) >= 0.9 ? 'text-rose-600 dark:text-rose-400' : (item.reserveUsed / item.reserveQuota) >= 0.7 ? 'text-amber-600 dark:text-amber-400' : 'text-slate-700 dark:text-slate-200'">
                                        {{ item.reserveUsed | number }}
                                    </span>
                                    <span class="text-[10px] text-slate-400">/</span>
                                    <span class="text-xs text-slate-500 dark:text-slate-400 font-bold">{{
                                        item.reserveQuota | number }}</span>
                                </div>
                                <!-- Progress bar -->
                                <div class="w-20 h-1.5 bg-slate-100 dark:bg-slate-700 rounded-full overflow-hidden">
                                    <div class="h-full rounded-full transition-all duration-500"
                                        [style.width.%]="item.reserveQuota > 0 ? (item.reserveUsed / item.reserveQuota) * 100 : 0"
                                        [ngClass]="(item.reserveUsed / item.reserveQuota) >= 0.9 ? 'bg-rose-400' : (item.reserveUsed / item.reserveQuota) >= 0.7 ? 'bg-amber-400' : 'bg-emerald-400'">
                                    </div>
                                </div>
                                <span class="text-[9px] font-bold"
                                    [ngClass]="(item.reserveUsed / item.reserveQuota) >= 0.9 ? 'text-rose-400' : (item.reserveUsed / item.reserveQuota) >= 0.7 ? 'text-amber-400' : 'text-emerald-400'">
                                    {{ item.reserveQuota > 0 ? ((item.reserveUsed / item.reserveQuota) * 100 |
                                    number:'1.0-0') : 0 }}%
                                </span>
                            </div>
                        </td>

                        <!-- Active / Total Cars -->
                        <td class="px-5 py-4 text-center align-middle">
                            <div class="flex flex-col items-center gap-0.5">
                                <span class="text-sm font-black text-emerald-600 dark:text-emerald-400">{{ item.carUsed
                                    | number }}</span>
                                <span class="text-[10px] text-slate-400">/{{ item.carTotal | number }} คัน</span>
                            </div>
                        </td>

                        <!-- Actions -->
                        <td class="px-5 py-4 text-center align-middle">
                            <div class="flex items-center justify-center gap-1.5">
                                <button (click)="onEdit(item)"
                                    class="w-8 h-8 flex items-center justify-center rounded-lg text-blue-500 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800/40 hover:bg-blue-500 hover:text-white hover:border-blue-500 transition-all active:scale-95"
                                    title="แก้ไข">
                                    <span class="material-icons text-[16px]">edit</span>
                                </button>
                                <button (click)="onDelete(item)"
                                    class="w-8 h-8 flex items-center justify-center rounded-lg text-rose-500 bg-rose-50 dark:bg-rose-900/20 border border-rose-100 dark:border-rose-800/40 hover:bg-rose-500 hover:text-white hover:border-rose-500 transition-all active:scale-95"
                                    title="ลบ">
                                    <span class="material-icons text-[16px]">delete_outline</span>
                                </button>
                            </div>
                        </td>
                    </tr>

                    <!-- Empty State -->
                    <tr *ngIf="totalItems === 0 && !isLoading">
                        <td colspan="8" class="py-24 text-center">
                            <div class="flex flex-col items-center justify-center">
                                <div
                                    class="w-16 h-16 bg-slate-100 dark:bg-slate-700 rounded-2xl flex items-center justify-center mb-4">
                                    <span
                                        class="material-icons text-3xl text-slate-300 dark:text-slate-500">search_off</span>
                                </div>
                                <h3 class="text-base font-bold text-slate-700 dark:text-slate-200 mb-1">
                                    ไม่พบข้อมูลบริษัท</h3>
                                <p class="text-sm text-slate-400">ลองเปลี่ยนคำค้นหาหรือรีเซ็ตตัวกรอง</p>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- ── Pagination ── -->
        <div
            class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 flex flex-col md:flex-row items-center justify-between gap-4">
            <div class="flex items-center gap-3 text-sm text-slate-500 font-medium">
                <span class="text-[11px]">แสดง <span class="font-bold text-slate-700 dark:text-slate-300">{{
                        startItemIndex | number }}</span> - <span
                        class="font-bold text-slate-700 dark:text-slate-300">{{ endItemIndex | number }}</span> จาก
                    <span class="font-bold text-slate-700 dark:text-slate-300">{{ totalItems | number }}</span>
                    รายการ</span>
                <div class="relative">
                    <select (change)="onPageSizeChange($event)" [(ngModel)]="pageSize"
                        class="appearance-none bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 text-xs rounded-lg py-1.5 pl-3 pr-7 focus:outline-none focus:ring-2 focus:ring-amber-200 font-bold cursor-pointer">
                        <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} รายการ</option>
                    </select>
                    <span
                        class="material-icons absolute right-1.5 top-1/2 -translate-y-1/2 text-slate-400 text-sm pointer-events-none">expand_more</span>
                </div>
            </div>

            <div class="flex items-center gap-1.5">
                <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
                    class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 text-slate-500 hover:bg-slate-50 hover:text-amber-500 disabled:opacity-30 disabled:cursor-not-allowed transition-all">
                    <span class="material-icons text-sm">chevron_left</span>
                </button>
                <button *ngFor="let page of pagesArray" (click)="setPage(page)"
                    class="w-9 h-9 flex items-center justify-center rounded-lg text-xs font-black transition-all duration-200"
                    [ngClass]="page === currentPage ? 'bg-amber-400 text-white shadow-lg shadow-amber-200/50' : 'text-slate-600 dark:text-slate-400 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600'">
                    {{ page }}
                </button>
                <button (click)="setPage(currentPage + 1)" [disabled]="currentPage === totalPages || totalPages === 0"
                    class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 text-slate-500 hover:bg-slate-50 hover:text-amber-500 disabled:opacity-30 disabled:cursor-not-allowed transition-all">
                    <span class="material-icons text-sm">chevron_right</span>
                </button>
            </div>
        </div>
    </div>
</div>

<app-modal-tenant-company *ngIf="isModalOpen" [mode]="modalMode" [data]="selectedData" (close)="closeModal()"
    (save)="saveModal($event)">
</app-modal-tenant-company>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>